export enum LocalStorageKey {
    UNALLOCATED_INSTALLATIONS_COUNT = 'UNALLOCATED_INSTALLATIONS_COUNT',
}
